import AbstractGuestlistDetailsPageController from './abstract-details-controller';

export default class GuestlistProtectedFilesPageController extends AbstractGuestlistDetailsPageController {

}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/protected-files-controller.js